import { combineReducers } from 'redux';

import continuedCoupons from './continuedCouponsReducer';
import wonCoupons from './wonCouponsReducer';
import lostCoupons from './lostCouponsReducer';
import savedCoupons from './savedCouponsReducer';
import tribunCoupons from './tribunCouponsReducer';
import couponDetail from './couponDetailReducer';
import deleteCouponById from './deleteCouponByIdReducer';
import outRightContinueCoupons from './outRightContinueCouponsReducer';
import outRightWonCoupons from './outRightWonCouponsReducer';
import outRightLostCoupons from './outRightLostCouponsReducer';
import outRightSavedCoupons from './outRightSavedCouponsReducer';
import rejectedCoupons from './rejectedCouponsReducer';
import eventStatusUpdate from './eventStatusUpdateReducer';
import activeFilter from './activeFilterReducer';
import systemCoupons from './systemCouponsReducer';
import iddaaCouponInfo from './iddaaCouponInfoReducer';
import tjkCouponInfo from './tjkCouponInfoReducer';
import secondaryHomeBanner from './secondaryHomeBannerReducer';


export default combineReducers({
  activeFilter,
  continuedCoupons,
  wonCoupons,
  lostCoupons,
  savedCoupons,
  tribunCoupons,
  couponDetail,
  deleteCouponById,
  outRightContinueCoupons,
  outRightWonCoupons,
  outRightLostCoupons,
  outRightSavedCoupons,
  rejectedCoupons,
  eventStatusUpdate,
  systemCoupons,
  iddaaCouponInfo,
  tjkCouponInfo,
  secondaryHomeBanner
});
